import { render } from "./PresetButton.vue?vue&type=template&id=722e15bd&scoped=true"
import script from "./PresetButton.vue?vue&type=script&lang=js"
export * from "./PresetButton.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-722e15bd"

export default script